import Notepad from '#/notes/components/Notepad'
import NotesSettingsTabs from '#/notes/components/NotesSettingsTabs'
import NoteTagsDataTable from '#/notes/components/NoteTagsDataTable'
import NoteTypesDataTable from '#/notes/components/NoteTypesDataTable'
import NotesDataTable from '#/notes/components/NotesDataTable'
import NoteEditor from '#/notes/components/NoteEditor'

const declareGlobalComponents = (Vue) => {
  Vue.component(Notepad.name, Notepad)
  Vue.component(NotesSettingsTabs.name, NotesSettingsTabs)
  Vue.component(NoteTagsDataTable.name, NoteTagsDataTable)
  Vue.component(NoteTypesDataTable.name, NoteTypesDataTable)
  Vue.component(NotesDataTable.name, NotesDataTable)
  // This component is a temporary measure for any BriteCore-UI component that wish to use the note editor.
  // This can be removed when an official editor is introduced in the BC-Design-System.
  Vue.component(NoteEditor.name, NoteEditor)
}

const BriteNotes = {
  install (Vue) {
    declareGlobalComponents(Vue)
  }
}

export default BriteNotes
